import React from 'react';
import CommitNumericFieldBase from './commit-numeric-field-base';

interface CommitOptionalNumberFieldProps {
  value: number | undefined;
  onCommit: (value: number | undefined) => void;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
}

/** Numeric field that may be left empty — clearing it commits `undefined`. */
const CommitOptionalNumberField: React.FC<CommitOptionalNumberFieldProps> = ({ value, onCommit, placeholder = '—', ...rest }) => (
  <CommitNumericFieldBase
    {...rest}
    value={value}
    placeholder={placeholder}
    format={String}
    onCommit={onCommit}
    onCommitEmpty={() => {
      if (value !== undefined) onCommit(undefined);
    }}
  />
);

export default CommitOptionalNumberField;
